// Untouched stored numbers (possibly saved before the current pattern existed) are never re-sent, so they
// cannot fail validation on unrelated edits. A blank value means the user wants the number removed.
export const getPhoneNumberUpdate = (initial: string | null | undefined, current: string | null | undefined) => {
  const trimmedCurrent = (current ?? '').trim();
  if (trimmedCurrent === (initial ?? '').trim()) {
    return {};
  }
  return { phoneNumber: trimmedCurrent === '' ? null : trimmedCurrent };
};
